import InvestorQualification from './InvestorQualification';
import AccreditationFirst from './Types/AccreditationFirst';
import InvestmentAccreditation from './Types/InvestmentAccreditation';
import IndependentQualification from './Types/IndependentQualification';
import AddWalletQualification from './Types/AddWalletQualification';

export default InvestorQualification;
export {
  AccreditationFirst,
  InvestmentAccreditation,
  IndependentQualification,
  AddWalletQualification,
};
